import { FunctionComponent, useEffect, useState } from 'react';
import KpiCard from './KpiCard';
import { getUncatchEndpointData } from '../utils/request';

type ScoreboardPayload = {
  kpis: {
    empresas: number;
    regionesCubiertas: number;
    regionesTotal: number;
    alimentadores: number;
    kmRed: number;
    clientesBt: number;
  };
  comparaciones: {
    empresas: string;
    regionesCubiertas: string;
    alimentadores: string;
    kmRed: string;
    clientesBt: string;
  };
};

const VALORES_INICIALES: ScoreboardPayload = {
  kpis: {
    empresas: 0,
    regionesCubiertas: 0,
    regionesTotal: 16,
    alimentadores: 0,
    kmRed: 0,
    clientesBt: 0
  },
  comparaciones: {
    empresas: '',
    regionesCubiertas: '',
    alimentadores: '',
    kmRed: '',
    clientesBt: ''
  }
};

const HeroKpiScoreboard: FunctionComponent = () => {
  const [payload, setPayload] = useState<ScoreboardPayload>(VALORES_INICIALES);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelado = false;
    const fetchData = async () => {
      try {
        const res = await getUncatchEndpointData({
          endpoint: 'penetracion/scoreboard'
        });
        if (cancelado) return;
        setPayload(res as ScoreboardPayload);
        setError(null);
      } catch (err) {
        if (cancelado) return;
        console.error(err);
        setError('No se pudieron cargar las cifras de adopción.');
      }
    };
    fetchData();
    return () => {
      cancelado = true;
    };
  }, []);

  if (error) {
    return <div className='kpi-card-status kpi-card-status--error'>{error}</div>;
  }

  const { kpis, comparaciones } = payload;

  return (
    <div className='bloque1-hero-row'>
      <KpiCard
        valor={kpis.empresas}
        label='Empresas que comparten sus redes'
        comparacion={comparaciones.empresas}
        variante='hero'
      />
      <KpiCard
        valor={kpis.regionesCubiertas}
        denominador={kpis.regionesTotal}
        formato='fraccion'
        label='Regiones del país con datos'
        comparacion={comparaciones.regionesCubiertas}
        variante='hero'
      />
      <KpiCard
        valor={kpis.alimentadores}
        label='Alimentadores en alta resolución'
        comparacion={comparaciones.alimentadores}
        variante='hero'
      />
      <KpiCard
        valor={kpis.kmRed}
        formato='decimal1'
        label='Kilómetros de red modelados'
        comparacion={comparaciones.kmRed}
        variante='hero'
      />
      <KpiCard
        valor={kpis.clientesBt}
        label='Clientes BT modelados'
        comparacion={comparaciones.clientesBt}
        variante='hero'
      />
    </div>
  );
};

export default HeroKpiScoreboard;
